/**
 * Adds click event listener to each accordion item to toggle "active" class.
 * Removes "active" class from all items, then adds it to clicked item.
 */
const accordionToggle = () => {
    const accordionList = document.querySelectorAll('[data-name="accordions-item"]');
    accordionList.forEach((accordion) => accordion.addEventListener("click", function (e) {
        const target = e.target;
        const currentTarget = e.currentTarget;
        if (target.parentElement !== currentTarget)
            return;
        if ((accordion.classList.contains("active"))) {
            accordion.classList.remove("active");
        }
        else {
            accordionList.forEach((accordion) => accordion.classList.remove("active"));
            accordion.classList.add("active");
        }
        const elementToView = document.querySelector(".product-accordions");
        if (elementToView) {
            elementToView.scrollIntoView();
        }
    }));
};
accordionToggle();
